import { render, staticRenderFns } from "./SplitPage.vue?vue&type=template&id=c1d284f8&"
var script = {}
import style0 from "./SplitPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports